import { Typography, Box, Link, Button } from '@mui/material'
import { footerStyles } from './footer.styles'
import { useStyles } from '@sweatpals/react-ui-kit'
import Logo from 'components/ui-v2/logo/logo.component'
import { SOCIAL_MEDIA_LINKS, TYPEFORM_URL, TYPEFORM_AMBASSADOR_URL, BOOK_DEMO_URL, CAREER_PAGE_URL } from '../../../constants'
import ExternalLink from 'components/links/External-link'
import useLink from '../../../utils/hooks/useLink'

// TODO: RD-2377 - delete this footer and refactor the one in @sweatpals/react-ui-kit to use it both in landing and web-app
export const Footer = () => {
  const styles = useStyles(footerStyles)
  const { makeDashboardLink } = useLink();

  return (
    <>
      <Box id="page-footer" sx={{backgroundColor: '#000000'}}>
				<Box sx={styles.footer.innerWrapper}>
					<Logo type="light-text" sx={styles.footer.logo} />
					<Box sx={styles.footer.columnsWrapper}>
						<Box sx={styles.footer.column}>
							<Typography sx={styles.footer.columnTitle}>Discover</Typography>
							<Link href="/blogs">
								<Typography sx={styles.footer.columnLink}>Blogs</Typography>
							</Link>
							<Link href="/events">
								<Typography sx={styles.footer.columnLink}>Events</Typography>
							</Link>
							<Link href="/create/community">
								<Typography sx={styles.footer.columnLink}>Create a community</Typography>
							</Link>
							<Link href="/create/event">
								<Typography sx={styles.footer.columnLink}>Promote my events</Typography>
							</Link>
						</Box>
						<Box sx={styles.footer.column}>
							<Typography sx={styles.footer.columnTitle}>Business</Typography>
							<Link href="/create/event">
								<Typography sx={styles.footer.columnLink}>Promote my events</Typography>
							</Link>
							<Link href="/create/community">
								<Typography sx={styles.footer.columnLink}>Grow my community</Typography>
							</Link>
							<ExternalLink href={BOOK_DEMO_URL}>
								<Typography sx={styles.footer.columnLink}>Book a demo</Typography>
							</ExternalLink>
							<Link href={TYPEFORM_URL}>
								<Typography sx={styles.footer.columnLink}>Brand Partnership</Typography>
							</Link>
							<Link href={TYPEFORM_URL}>
								<Typography sx={styles.footer.columnLink}>Corporate Offerings</Typography>
							</Link>
							<Link href={TYPEFORM_AMBASSADOR_URL}>
								<Typography sx={styles.footer.columnLink}>Become an Ambassador</Typography>
							</Link>
							<ExternalLink href={CAREER_PAGE_URL}>
								<Typography sx={styles.footer.columnLink}>Careers</Typography>
							</ExternalLink>
							<Link href={TYPEFORM_URL}>
								<Typography sx={styles.footer.columnLink}>Contact Us</Typography>
							</Link>
						</Box>
						<Box sx={styles.footer.column}>
							<Typography sx={styles.footer.columnTitle}>App</Typography>
							<ExternalLink href={makeDashboardLink()}>
								<Typography sx={styles.footer.columnLink}>Sign in / Sign up</Typography>
							</ExternalLink>
							<Link href="/download">
								<Typography sx={styles.footer.columnLink}>Download App for Free</Typography>
							</Link>
							<Link href={TYPEFORM_URL}>
								<Typography sx={styles.footer.columnLink}>App Support</Typography>
							</Link>
							<Link href="/download">
								<Typography sx={styles.footer.columnLink}>Download Page</Typography>
							</Link>
						</Box>
						<Box sx={{ ...styles.footer.column, textAlign: 'left', maxWidth: '380px' }}>
							<Typography
								sx={{
									color: 'rgba(242, 246, 250, 1)',
									fontSize: '18px',
									lineHeight: '32px',
									fontWeight: 600,
									fontFamily: 'Montserrat',
								}}
							>
								Subscribe to Newsletter
							</Typography>
							<Typography
								sx={{
									color: 'rgba(191, 193, 201, 1)',
									fontSize: '16px',
									lineHeight: '26px',
									fontWeight: 400,
									fontFamily: 'Montserrat',
									marginBottom: '8px',
								}}
							>
								Get the latest news and updates from SweatPals
							</Typography>
							<input
								placeholder="Enter your email"
								style={{
									width: '100%',
									border: 'none',
									background: 'rgba(255, 255, 255, 0.1)',
									borderRadius: '8px',
									padding: '10px 16px',
									marginBottom: '8px',
									color: 'rgba(255, 255, 255, 0.6)',
									fontSize: '16px',
									lineHeight: '19px',
									fontWeight: 400,
									fontFamily: 'Montserrat',
								}}
							/>
							<Button variant="contained" sx={{ ...styles.actionButton, width: 'fit-content' }}>
								Subscribe
							</Button>
						</Box>
					</Box>
				</Box>
			</Box>
			<Box id="copyright" sx={{backgroundColor: '#000000'}}>
				<Box sx={styles.copyright.innerWrapper}>
					<Box sx={{ textAlign: 'left' }}>
						<Typography
							sx={{
								color: '#F2F6FA',
								fontWeight: 600,
								fontSize: '12px',
								lineHeight: '15px',
								textTransform: 'uppercase',
								fontFamily: 'Integral CF',
							}}
						>
							Made with ❤️
						</Typography>
						<Typography
							sx={{
								color: 'rgba(255, 255, 255, 0.5)',
								fontWeight: 400,
								fontSize: '12px',
								lineHeight: '15px',
								textTransform: 'uppercase',
								fontFamily: 'Integral CF',
							}}
						>
							<sup>©</sup>SWEATPALS 2025
						</Typography>
					</Box>
					<Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
						<ExternalLink href={SOCIAL_MEDIA_LINKS.tiktok}>
							<svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M16.6002 6.32C15.9166 5.53962 15.5399 4.53743 15.5402 3.5H12.4502V15.9C12.4263 16.571 12.143 17.2066 11.6599 17.6729C11.1768 18.1393 10.5316 18.3999 9.86016 18.4C8.44016 18.4 7.26016 17.24 7.26016 15.8C7.26016 14.08 8.92016 12.79 10.6302 13.32V10.16C7.18016 9.7 4.16016 12.38 4.16016 15.8C4.16016 19.13 6.92016 21.5 9.85016 21.5C12.9902 21.5 15.5402 18.95 15.5402 15.8V9.51C16.7932 10.4099 18.2975 10.8926 19.8402 10.89V7.8C19.8402 7.8 17.9602 7.89 16.6002 6.32Z"
									fill="white"
									fillOpacity="0.8"
								/>
							</svg>
						</ExternalLink>
						<ExternalLink href={SOCIAL_MEDIA_LINKS.facebook}>
							<svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M9.19873 22H13.1987V13.99H16.8027L17.1987 10.01H13.1987V8C13.1987 7.73478 13.3041 7.48043 13.4916 7.29289C13.6792 7.10536 13.9335 7 14.1987 7H17.1987V3H14.1987C12.8727 3 11.6009 3.52678 10.6632 4.46447C9.72552 5.40215 9.19873 6.67392 9.19873 8V10.01H7.19873L6.80273 13.99H9.19873V22Z"
									fill="white"
									fillOpacity="0.8"
								/>
							</svg>
						</ExternalLink>
						<ExternalLink href={SOCIAL_MEDIA_LINKS.instagram}>
							<svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M17 2.5H7C4.23858 2.5 2 4.73858 2 7.5V17.5C2 20.2614 4.23858 22.5 7 22.5H17C19.7614 22.5 22 20.2614 22 17.5V7.5C22 4.73858 19.7614 2.5 17 2.5Z"
									stroke="white"
									strokeOpacity="0.8"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M17.4997 7H17.5097M15.9997 11.87C16.1231 12.7022 15.981 13.5522 15.5935 14.299C15.206 15.0458 14.5929 15.6514 13.8413 16.0297C13.0898 16.4079 12.2382 16.5396 11.4075 16.4059C10.5768 16.2723 9.80947 15.8801 9.21455 15.2852C8.61962 14.6902 8.22744 13.9229 8.09377 13.0922C7.96011 12.2616 8.09177 11.4099 8.47003 10.6584C8.84829 9.90685 9.45389 9.29374 10.2007 8.90624C10.9475 8.51874 11.7975 8.37659 12.6297 8.5C13.4786 8.62588 14.2646 9.02146 14.8714 9.62831C15.4782 10.2351 15.8738 11.0211 15.9997 11.87Z"
									stroke="white"
									strokeOpacity="0.8"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</ExternalLink>
					</Box>
				</Box>
			</Box>
    </>
  )
}
